import { c as _c } from "react/compiler-runtime";
import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { cn } from "../utils";
function Kbd(t0) {
  const $ = _c(10);
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    const {
      className,
      render,
      ...props
    } = t0;
    t4 = useRender;
    t1 = "kbd";
    t2 = render;
    t3 = mergeProps(props, {
      className: cn("pointer-events-none inline-flex h-5 w-fit min-w-5 items-center justify-center gap-1 rounded-sm bg-muted px-1 font-sans text-xs font-medium text-muted-foreground select-none [&_svg:not([class*='size-'])]:size-3 [[data-slot=tooltip-content]_&]:bg-background/20 [[data-slot=tooltip-content]_&]:text-background dark:[[data-slot=tooltip-content]_&]:bg-background/10", className)
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      slot: "kbd"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t6 = {
      defaultTagName: t1,
      render: t2,
      props: t3,
      state: t5
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t4(t6);
}
function KbdGroup(t0) {
  const $ = _c(10);
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    const {
      className,
      render,
      ...props
    } = t0;
    t4 = useRender;
    t1 = "div";
    t2 = render;
    t3 = mergeProps(props, {
      className: cn("inline-flex items-center gap-1", className)
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      slot: "kbd-group"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t6 = {
      defaultTagName: t1,
      render: t2,
      props: t3,
      state: t5
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t4(t6);
}
export { Kbd, KbdGroup };